import {
    Input as BUInput,
    StyledEndEnhancer,
    StyledInput,
    StyledInputContainer,
    StyledInputEnhancer,
    StyledRoot,
    StyledStartEnhancer
} from 'baseui/input'
import React, { ComponentProps } from 'react'
import { withStyle } from '../../theme'

export type InputProps = ComponentProps<typeof BUInput>

const BaseInput = withStyle(StyledInput, ({ $theme }) => ({
    paddingBottom: $theme.sizing.scale500,
    paddingTop: $theme.sizing.scale500,

    '::placeholder': {
        ...$theme.typography.ParagraphMedium
    }
}))

const BaseInputRoot = withStyle(StyledRoot, () => ({
    borderWidth: '1px'
}))

const BaseEndEnhancer = withStyle(StyledEndEnhancer, ({ $theme, $error }) => ({
    color: $error ? $theme.colors.negative : $theme.colors.mono400
}))

const Input = ({ ...props }: InputProps) => {
    return <BUInput overrides={{ Input: BaseInput, Root: BaseInputRoot, EndEnhancer: BaseEndEnhancer }} {...props} />
}

export default Input
export {
    BaseEndEnhancer,
    BaseInput,
    BaseInputRoot,
    StyledEndEnhancer,
    StyledInput,
    StyledInputContainer,
    StyledInputEnhancer,
    StyledRoot,
    StyledStartEnhancer
}
